module.exports = __webpack_public_path__ + "static/media/fretador-logo.8cf292e2.png";